import React, {useState} from 'react';
import './DeleteTaskForm.scss';
import { closeEditPaidTaskForm, updatePaidOptionTask} from '../../../MainVIew/Tasks/taskSlice';


const EditPaidTaskForm = (props) => {

     const [priceInputValue, setPriceInputValue] = useState('');
    const [paidOption, setPaidOption] = useState(false);

    const { dispatch } = props;
 // CLICK OK
 
 const onSend = () => {
      
    console.log('Start edit task action');

        const data = {
            taskId: props.taskId,
            paid: paidOption,
            price: priceInputValue
            
        }
        console.log(data);

        dispatch(updatePaidOptionTask(data));
       
    
       dispatch(closeEditPaidTaskForm());
       setPriceInputValue('');
       setPaidOption(false);
    }
    

    // CLOSE FORM
    const onClose = () => {
        const { dispatch } = props;
       
    dispatch(closeEditPaidTaskForm());
    setPriceInputValue('');
    setPaidOption(false);
    

    }
    //CHECK PUBLIC
    const handleSetPublicOption = () => {
        setPaidOption(!paidOption);

    };
            //HANDLE PRICE OF TASK
    const handlePriceTask = (event) => {
        
        setPriceInputValue(event.target.value);
    }

    const render = () => {

        
            return(
                <div className="DeleteTaskForm">
                    
                <p><b>Изменение статуса задачи:</b></p>
                <div className="container-column">
                    <label htmlFor="checkboxPaid">Установить статус задачи:</label>
                     <div className='container-row'>
                        <input  className="check-box" type="checkbox" id="checkboxPaid"
                                    onChange={handleSetPublicOption} 
                                    ></input>
                                    <p className='small-p'>(платная)</p>
                    </div>
                </div >
                <div className="container-column">
                    <label htmlFor="task-price">Задайте цену  в рублях:</label>
                        <input id="task-price" name="task-price" value ={priceInputValue} 
                                    placeholder=' стоимость ' onChange={handlePriceTask}></input>
                    <button onClick={onSend}>Сохранить</button>
                    <button onClick={onClose}>Отмена</button>
                </div>      
                </div>
            )
       
   
    }
return render();
}
export default EditPaidTaskForm;
  